import {onReady} from "../../utils/events/onReady";
import {debounce} from "alpinejs/src/utils/debounce";

export class Schema {
    data = {};
    dom = {
        container: undefined,
        dropWrapper: undefined
    };

    breakpoint = 901;

    constructor(domReference) {
        this.dom.container = domReference;
        this.dom.dropWrapper = domReference.querySelectorAll(".schema-drop__wrapper");
        onReady(() => this.schema());
    }

    schemaDropResize = () => {
        if (window.innerWidth <= this.breakpoint) {
            this.unsetHeight()
        } else {
            this.dom.dropWrapper.forEach((wrapper) => {
                if (wrapper.classList.contains("schema-is-active")) {
                    this.open(wrapper)
                } else {
                    this.close(wrapper)
                }
            })
        }

    }

    open = (wrapper) => {
        let schemaDropHeight = wrapper.querySelector(".schema-row").offsetHeight;
        wrapper.style.height = schemaDropHeight + 2 + "px";
    }

    close = (wrapper) => {
        wrapper.style.height = wrapper.scrollHeight + "px";
    }

    toggleWrapper = (wrapper) => {
        if (window.innerWidth > this.breakpoint) {
            let schemaFullHeight = wrapper.offsetHeight;

            wrapper.style.height = schemaFullHeight + "px";
            wrapper.classList.toggle("schema-is-active")

            if (wrapper.classList.contains("schema-is-active")) {
                this.open(wrapper)

            } else {
                this.close(wrapper)
            }
        }
    }

    schemaDrop = (e) => {
        let wrapper = e.currentTarget.closest(".schema-drop__wrapper");
        this.toggleWrapper(wrapper);
    }


    unsetHeight = () => {
        this.dom.dropWrapper.forEach((wrapper) => {
            wrapper.style.height = null;
        });
    }

    schema() {
        window.addEventListener("resize", debounce(this.schemaDropResize, 10))

        this.dom.dropWrapper.forEach((wrapper) => {
            let schemaDropHeading = wrapper.querySelector(".schema-row");
            schemaDropHeading.addEventListener("click", this.schemaDrop)
            wrapper.addEventListener("keypress", function (event) {
                if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    schemaDropHeading.click();
                }
            });
        })
    }
}
